import Divider from './Divider';

export * from './Divider';

export default Divider;
